import React from "react";
import { FaRegCircleXmark } from "react-icons/fa6";

/**
 * ImageEnlargeOverlay component displays an enlarged image in an overlay
 * @param {Object} image - The image object to display {url, filename, etc.}
 * @param {Function} onClose - Function to call when closing the overlay
 */
const ImageEnlargeOverlay = ({ image, onClose }) => {
  if (!image) return null;

  return (
    <div
      className="fixed inset-0 bg-black bg-opacity-75 flex items-center justify-center z-50"
      onClick={onClose}
    >
      <div className="h-[628px] w-[514px] bg-pink150 rounded-[15px] shadow-lg flex flex-col items-center p-[24px] justify-start ">
        <div className="flex justify-center rounded-[15px] shadow ">
          <img
            src={image.url}
            alt="Enlarged image"
            className="object-cover rounded-[15px]"
            onClick={(e) => e.stopPropagation()}
          />
        </div>
        <button
          onClick={onClose}
          className="mt-[45px] text-4xl text-white hover:text-gray-150 transition-colors"
        >
          <FaRegCircleXmark size={48} />
        </button>
      </div>
    </div>
  );
};

export default ImageEnlargeOverlay;
